import { campaignTableHeader } from '../../../../assets/helpers/tables';
import useCampaign from '../../../../hooks/params/useCampaign';
import { ActionButton } from '../../../common/Buttons/Buttons';
import { CampaignTable } from '../../../common/Tables/Tables';
import { itemsPerPageOptions } from '../parametersConstants';
import CampaignForm from './CampaignForm';
import DefaultSettingSection from './DefaultSettings/DefaultSettingSection';

export default function CampaignParametersSection() {
  const {
    register,
    errors,
    showCampingForm,
    setShowCampingForm,
    campaignData,
    editingCampaignId,
    handleCampaignPageChange,
    handleToggleCampaignActive,
    handleEditCampaign,
    onSubmit,
    onCampaignSelectPerPage,
    inactiveCampaigns,
    closeForm,
    setValue,
    getValues,
    control,
  } = useCampaign();
  return (
    <>
      <DefaultSettingSection />
      <div className="parameters-page__pills-row" style={{ justifyContent: 'flex-end'}}>
        <ActionButton
          type="button"
          action={() => setShowCampingForm((s) => !s)}
          label={'+ Nueva campaña'}
        />
      </div>
      <CampaignTable
        header={campaignTableHeader}
        data={campaignData}
        handlePageChange={handleCampaignPageChange}
        onToggleActive={handleToggleCampaignActive}
        onEdit={handleEditCampaign}
        itemsPerPageOptions={itemsPerPageOptions}
        onPerPageChange={onCampaignSelectPerPage}
        inactiveCount={inactiveCampaigns}
      />
    <CampaignForm
        isOpen={showCampingForm}
        onClose={closeForm}
        onSubmit={onSubmit}
        register={register}
        errors={errors}
        editingCampaignId={editingCampaignId}
        setValue={setValue}
        getValues={getValues}
        control={control}
    />
    </>
  );
}
